import {ApiHealthCentersShortListItemResponse} from './api-health-centers-short-list-item-response';
import {FromMessageInterface} from '../../../../core/services/http/from-message.interface';

export class HealthCenterShort implements FromMessageInterface<ApiHealthCentersShortListItemResponse> {

  public id: string = '';
  public name: string = '';

  public fromMessage(message: ApiHealthCentersShortListItemResponse): this {
    this.id = message.id;
    this.name = message.name;
    return this;
  }

  public toString(): string {
    return this.name;
  }

}
